import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';
import { getBanca, updateBanca } from '../services/api';
import { Form, Button, Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';

const BancheEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const tornaIndietro = useTornaIndietro('/banche');
  const [formData, setFormData] = useState({
    denominazione: '',
    telefono: '',
    cellulare: '',
    email: '',
    iban: '',
    bic: '',
    costo_transazione_percentuale: '',
    referente: '',
    firefly_asset_account_name: '',
    use_for_ecommerce_bonifico: false // Nuovo campo
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanca = async () => {
      try {
        const response = await getBanca(id);
        // Assicurati che il campo booleano sia un booleano
        setFormData({ ...response.data, use_for_ecommerce_bonifico: !!response.data.use_for_ecommerce_bonifico });
        setLoading(false);
      } catch (err) {
        setError('Errore nel caricamento della banca.');
        setLoading(false);
      }
    };
    fetchBanca();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateBanca(id, formData);
      alert('Banca aggiornata con successo!');
      navigate('/banche');
    } catch (error) {
      console.error("Errore nell'aggiornamento della banca:", error);
      alert("Errore nell'aggiornamento della banca.");
    }
  };

  if (loading) {
    return <Spinner animation="border" />;
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  return (
    <Container>
        <Row className="align-items-center mb-3">
            <Col>
                <h2>Modifica Banca</h2>
            </Col>
            <Col xs="auto" className="ms-auto">
                <Button variant="secondary" onClick={tornaIndietro} className="me-2">
                    Torna alla Lista
                </Button>
                <Button variant="primary" type="submit" form="banca-edit-form">
                    Salva Modifiche
                </Button>
            </Col>
        </Row>
      <Form id="banca-edit-form" onSubmit={handleSubmit}>
        <Card className="mb-3">
          <Card.Header>Dati Banca</Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Denominazione</Form.Label>
                  <Form.Control type="text" name="denominazione" value={formData.denominazione || ''} onChange={handleChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Referente</Form.Label>
                  <Form.Control type="text" name="referente" value={formData.referente || ''} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Telefono</Form.Label>
                  <Form.Control type="text" name="telefono" value={formData.telefono || ''} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Cellulare</Form.Label>
                  <Form.Control type="text" name="cellulare" value={formData.cellulare || ''} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" name="email" value={formData.email || ''} onChange={handleChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Usa per bonifici e-commerce"
                name="use_for_ecommerce_bonifico"
                checked={formData.use_for_ecommerce_bonifico || false}
                onChange={handleChange}
              />
              <Form.Text className="text-muted">
                Spuntare se questa banca deve essere usata per mostrare le coordinate in caso di pagamento con bonifico per ordini e-commerce.
              </Form.Text>
            </Form.Group>
          </Card.Body>
        </Card>

        <Card className="mb-3">
          <Card.Header>Dati Bancari</Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>IBAN</Form.Label>
                  <Form.Control type="text" name="iban" value={formData.iban || ''} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>BIC/Swift</Form.Label>
                  <Form.Control type="text" name="bic" value={formData.bic || ''} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Costo Transazione (%)</Form.Label>
              <Form.Control type="number" step="0.01" name="costo_transazione_percentuale" value={formData.costo_transazione_percentuale || ''} onChange={handleChange} />
            </Form.Group>
          </Card.Body>
        </Card>

        <Card className="mb-3">
          <Card.Header>Integrazione Firefly III</Card.Header>
          <Card.Body>
            <Form.Group className="mb-3">
              <Form.Label>Nome Conto Patrimoniale Firefly III</Form.Label>
              <Form.Control 
                type="text" 
                name="firefly_asset_account_name" 
                value={formData.firefly_asset_account_name || ''} 
                onChange={handleChange} 
                placeholder="Es: Conto Corrente Principale"
              />
              <Form.Text className="text-muted">
                Inserire il nome esatto del conto patrimoniale (asset account) su Firefly III.
              </Form.Text>
            </Form.Group>
          </Card.Body>
        </Card>

      </Form>
    </Container>
  );
};

export default BancheEdit;